<template>
    <div>
    <o-table :title="$t('sandoz.products')" ref="tableList" url="/api/sandoz/product_masters" :enable-delete="false">
        <template slot="filter">
            <div class="d-flex">
                <div>
                    <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                        <o-filter-text :title="$t('sandoz.identifier')" column="product_master_id"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.name')" column="product_name"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.year')" column="year"></o-filter-text>
                        <o-filter-select :items="statuses" :title="$t('sandoz.status')"
                                    column="status" value-field="value"
                                    text-field="text"></o-filter-select>
                        <o-filter-select :items="type" :title="$t('sandoz.type')" column="type" value-field="value"
                                        text-field="text"></o-filter-select>
                        <o-filter-select :items="needsVerification" :title="$t('sandoz.needs_verification')"
                                        column="needs_verification" value-field="value"
                                        text-field="text"></o-filter-select>
                        <o-filter-select :items="productGroups" :title="$t('sandoz.product_group')"
                                        column="product_group" value-field="value"
                                        text-field="product_group"></o-filter-select>
                        <o-filter-select :items="productDistributors" :title="$t('sandoz.distributor')"
                                        column="distributor" value-field="value"
                                        text-field="distributor"></o-filter-select>
                        <o-filter-text :title="$t('sandoz.sales_line')" column="sales_line"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.product_id')" column="product_id"></o-filter-text>
                    </o-filter>
                </div>
                <div class="ml-auto">
                <div class="spinner-border text-primary mr-3" role="status" v-if="productExporting">
                    <span class="sr-only"></span>
                </div>
                <o-button @click.prevent="productExport()" v-else :loading="productExporting">Export</o-button>
                </div>
            </div>
        </template>
        <template slot="head">
            <o-table-header column="id">{{$t('core.id')}}</o-table-header>
            <o-table-header column="product_master_id">{{$t('sandoz.identifier')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.name')}}</o-table-header>
            <o-table-header column="year">{{$t('sandoz.year')}}</o-table-header>
            <o-table-header column="status">{{$t('sandoz.status')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.product_master_id }}</td>
            <td>{{ props.item.product ? props.item.product.name : "" }}</td>
            <td>{{ props.item.year ? props.item.year : '*' }}</td>
            <td>
                <span class="badge" :class="{'badge-success': props.item.status == 'active', 'badge-warning': props.item.status == 'legacy', 'badge-danger': props.item.status == 'inactive'}">
                    {{$t('sandoz.' + props.item.status)}}
                </span>
            </td>
        </template>
        <template slot="body-controls" slot-scope="props">
            <td class="text-right">
                <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                    <b-btn @click="cloneProduct(props.item)" class="btn btn-secondary">
                        <fa icon="clone"/>
                    </b-btn>
                    <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
                    <fa icon="pencil-alt"/>
                    </router-link>
                </div>
            </td>
        </template>
    </o-table>

    <b-modal ref="productCloneModal" :title="$t('sandoz.clone_product')" size="l" @ok="cloneApiProduct">
            <div class="d-block text-center">

                <b-form-group :class="identifierErrorMessage !== null ? 'has-error': ''" id="cloneProductIdentifierFormGroup" label-cols-sm="4" label-cols-lg="3" :label="$t('sandoz.identifier')" label-for="cloneProductIdentifier" label-align="right">
                    <input id="cloneProductIdentifier" v-model="cloneProductIdentifier" type="text" class="form-control">
                    <small class="form-text text-muted text-left">{{ $t('sandoz.clone_identifier_hint') }}</small>
                    <div class="text-danger text-left">
                        {{ this.identifierErrorMessage }}
                    </div>
                </b-form-group>

                <b-form-group :class="currentYearErrorMessage !== null ? 'has-error': ''" id="cloneProductYearFormGroup" label-cols-sm="4" label-cols-lg="3" :label="$t('sandoz.year')" label-for="cloneProductYear" label-align="right">
                    <input id="cloneProductYear" v-model="cloneProductYear" type="number" :max="currentYear" class="form-control" onkeypress="return this.value.length < 4;" oninput="if(this.value.length>=4) { this.value = this.value.slice(0,4); }">
                    <div class="text-danger text-left">
                        {{  this.currentYearErrorMessage }}
                    </div>
                </b-form-group>

                <b-form-group id="cloneProductSubItemFormGroup" label-cols-sm="4" label-cols-lg="3" label=""
                              label-for="cloneProductSubItem" label-align="right" class="text-left">
                    <b-form-checkbox id="cloneProductSubItem" v-model="cloneProductSubItem" class="mt-2">{{$t('sandoz.copy_subitems')}}</b-form-checkbox>
                </b-form-group>

            </div>

             <template #modal-footer="{ cancel, ok }">
                <b-button @click="cancel()">
                    {{$t('core.cancel')}}
                </b-button>
                <b-button variant="primary" @click="ok()">
                    {{$t('core.clone')}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data: () => ({
            type: [],
            needsVerification: [],
            productGroups: [],
            productDistributors: [],
            statuses: [],
            productExporting: false,
            cloneProductYear: null,
            cloneProductIdentifier: null,
            cloneProductSubItem: false,
            cloneProductID: null,
            currentYear: null,
            currentYearErrorMessage: null,
            identifierErrorMessage: null
        }),
        created() {
            this.type = [
                {value: 'service', text: this.$i18n.t('sandoz.service')},
                {value: 'marketing_activity', text: this.$i18n.t('sandoz.marketing_activity')}
            ]
            this.needsVerification = [
                {value: 1, text: this.$i18n.t('sandoz.yes')},
                {value: 0, text: this.$i18n.t('sandoz.no')}
            ]
            this.statuses = [
                {value: 'active', text: this.$i18n.t('sandoz.active')},
                {value: 'legacy', text: this.$i18n.t('sandoz.legacy')},
                {value: 'inactive', text: this.$i18n.t('sandoz.inactive')}
            ]

            const d = new Date();
            this.currentYear = d.getFullYear();
        },
        mounted() {
          this.groups()
          this.distributors()
        },
        methods: {
            groups() {
                axios.get('/api/sandoz/product_masters/filter/product_group').then((response) => {
                    this.productGroups = response.data
                }).catch((error) => {
                    console.error(error)
                })
            },
            distributors() {
                axios.get('/api/sandoz/product_masters/filter/distributor').then((response) => {
                    this.productDistributors = response.data
                    this.productDistributors.unshift({value : null, distributor: this.$t('sandoz.all_distributors')})
                }).catch((error) => {
                    console.error(error)
                })
            },
            productExport() {
                this.productExporting = true
                axios.get('/api/sandoz/product_masters/export', { responseType: 'arraybuffer' }).then((response) => {
                    this.productExporting = false
                    require('downloadjs')(response.data,
                    'Products.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    )
                }).catch((error) => {
                    console.error(error)
                })
            },
            cloneProduct(product) {
                if(product.year === null) {
                    this.$notify({
                        text: this.$i18n.t('sandoz.product_clone_error'),
                        title: this.$i18n.t('core.save_error'),
                        type: 'error'
                    })
                } else {

                    const self = this
                    self.cloneProductID = product.id
                    self.cloneProductSubItem = false
                    self.cloneProductYear = null
                    self.cloneProductIdentifier = product.product_master_id
                    self.currentYearErrorMessage = null
                    self.identifierErrorMessage = null
                    self.$refs.productCloneModal.show()
                    return
                }
                
            },
            cloneApiProduct(evt) {

                evt.preventDefault()
                this.currentYearErrorMessage = null
                this.identifierErrorMessage = null

                if(this.cloneProductYear === null) {
                    this.currentYearErrorMessage = "This field is required"
                    return false;
                } 

                if(this.cloneProductYear.length !== 4) {
                    this.currentYearErrorMessage = "Please enter valid year e.g. "+this.currentYear
                    return false;
                }

                const identifier = this.cloneProductIdentifier ? this.cloneProductIdentifier.trim() : ''
                if(identifier === '') {
                    this.identifierErrorMessage = "This field is required"
                    return false;
                }

                var my = this
                var formData = {
                    year: this.cloneProductYear,
                    product_master_id: identifier,
                    cloneProductSubItem: this.cloneProductSubItem,
                    cloneProductID: this.cloneProductID,
                }

                axios.post('/api/sandoz/product_masters/clone', formData)
                .then((response) => {
                    my.$refs.productCloneModal.hide()
                    if(response.data.success) {
                        my.$notify({
                            title: this.$i18n.t('core.saved'),
                            text: this.$i18n.t('sandoz.product_clone_success')
                        })

                        my.$refs.tableList.changePage(1)
                    } else {
                        my.$notify({
                            title: this.$i18n.t('core.save_error'),
                            text: response.data.message
                        })
                    }
                })
                .catch((error) => {
                })
            }
        }
    }
</script>
